export const LANGS = ["it", "en"];

// Static UI copy only — content coming from the CMS (settings, event/product
// descriptions...) stays in whatever language the admin wrote it in.
export const STRINGS = {
    it: {
        nav_home: "Home",
        nav_events: "Eventi",
        nav_club: "Il Club",
        nav_archive: "Archivio",
        nav_news: "News",
        nav_shop: "Shop",
        nav_private: "Eventi Privati",
        nav_contact: "Contatti",
        header_login: "Accedi",
        header_logout: "Esci",
        header_admin: "Area Admin",
        header_whatsapp: "WhatsApp",
        footer_faq: "FAQ",

        floorplan_kicker: "Piantina Ufficiale",
        floorplan_title: "Scegli il tuo tavolo",
        floorplan_intro: "Piantina ufficiale del Glitz Club. Tocca un tavolo libero per prenotare. I tavoli grigi sono già assegnati.",
        floorplan_view_3d: "Esplora in 3D",
        floorplan_view_2d: "Piantina 2D",
        floorplan_slow_title: "Connessione lenta?",
        floorplan_slow_body: "Passa alla piantina 2D, si carica all'istante.",
        floorplan_slow_dismiss: "Ignora",
        floorplan_reserved: "Prenotato",
        floorplan_fullscreen: "Vedi a schermo intero",
        floorplan_bottle_menu: "Listino bottiglie",
        floorplan_zone_active: "Zona evidenziata · Tocca per deselezionare",
        floorplan_zone_inactive: "Tocca per evidenziare in piantina",
        floorplan_from: "Da",
        floorplan_fullscreen_label: "Piantina",
        floorplan_footer_note: "Piantina ufficiale del Glitz Club. Le posizioni dei tavoli possono variare per singolo evento.",
        floorplan_scroll_hint: "Scorri orizzontalmente per vedere tutte le zone. Tocca un tavolo libero per prenotare.",

        booking_title: "Prenota Tavolo",
        booking_request_title: "Richiesta Tavolo",
        booking_table: "Tavolo",
        booking_night: "Serata",
        booking_zone: "Zona",
        booking_name: "Nome e Cognome",
        booking_phone: "Telefono / WhatsApp",
        booking_email: "Email (facoltativa)",
        booking_guests: "Ospiti",
        booking_note: "Note (facoltative)",
        booking_note_placeholder: "Compleanno, allergie, richieste particolari...",
        booking_submit: "Invia richiesta + WhatsApp",
        booking_sending: "Invio...",
        booking_disclaimer: "Salviamo la richiesta e apriamo WhatsApp per conferma diretta. Nessuno spam.",

        shop_size: "Taglia",
        shop_quantity: "Quantità",
        shop_delivery: "Consegna",
        shop_shipping: "Spedizione",
        shop_pickup: "Ritiro in club",
        shop_total: "Totale",
        shop_add_to_cart: "Aggiungi al carrello",
        shop_cart_checkout_note: "Nome, consegna e pagamento si scelgono al checkout nel carrello.",
        shop_pay_card: "Paga subito con carta",
        shop_order_whatsapp: "Ordina subito su WhatsApp",

        cart_title: "Carrello",
        cart_empty: "Il carrello è vuoto.",
        cart_name: "Nome e cognome",
        cart_phone: "Telefono",
        cart_email: "Email (facoltativa)",
        cart_address: "Indirizzo (Via, CAP, Città)",
        cart_submit: "Invia ordine via WhatsApp",
        cart_sending: "Invio...",
    },
    en: {
        nav_home: "Home",
        nav_events: "Events",
        nav_club: "The Club",
        nav_archive: "Archive",
        nav_news: "News",
        nav_shop: "Shop",
        nav_private: "Private Events",
        nav_contact: "Contact",
        header_login: "Sign in",
        header_logout: "Sign out",
        header_admin: "Admin Area",
        header_whatsapp: "WhatsApp",
        footer_faq: "FAQ",

        floorplan_kicker: "Official Floor Plan",
        floorplan_title: "Choose your table",
        floorplan_intro: "Official Glitz Club floor plan. Tap a free table to book. Grey tables are already taken.",
        floorplan_view_3d: "Explore in 3D",
        floorplan_view_2d: "2D floor plan",
        floorplan_slow_title: "Slow connection?",
        floorplan_slow_body: "Switch to the 2D floor plan — it loads instantly.",
        floorplan_slow_dismiss: "Dismiss",
        floorplan_reserved: "Booked",
        floorplan_fullscreen: "View fullscreen",
        floorplan_bottle_menu: "Bottle menu",
        floorplan_zone_active: "Zone highlighted · Tap to deselect",
        floorplan_zone_inactive: "Tap to highlight on the map",
        floorplan_from: "From",
        floorplan_fullscreen_label: "Floor plan",
        floorplan_footer_note: "Official Glitz Club floor plan. Table positions may vary per event.",
        floorplan_scroll_hint: "Scroll sideways to see every zone. Tap a free table to book.",

        booking_title: "Book a Table",
        booking_request_title: "Table Request",
        booking_table: "Table",
        booking_night: "Night",
        booking_zone: "Zone",
        booking_name: "Full Name",
        booking_phone: "Phone / WhatsApp",
        booking_email: "Email (optional)",
        booking_guests: "Guests",
        booking_note: "Notes (optional)",
        booking_note_placeholder: "Birthday, allergies, special requests...",
        booking_submit: "Send request + WhatsApp",
        booking_sending: "Sending...",
        booking_disclaimer: "We save your request and open WhatsApp for direct confirmation. No spam.",

        shop_size: "Size",
        shop_quantity: "Quantity",
        shop_delivery: "Delivery",
        shop_shipping: "Shipping",
        shop_pickup: "Pick up in club",
        shop_total: "Total",
        shop_add_to_cart: "Add to cart",
        shop_cart_checkout_note: "Name, delivery and payment are chosen at cart checkout.",
        shop_pay_card: "Pay now by card",
        shop_order_whatsapp: "Order now on WhatsApp",

        cart_title: "Cart",
        cart_empty: "Your cart is empty.",
        cart_name: "Full name",
        cart_phone: "Phone",
        cart_email: "Email (optional)",
        cart_address: "Address (street, ZIP, city)",
        cart_submit: "Send order via WhatsApp",
        cart_sending: "Sending...",
    },
};
